import { PropsWithChildren, useRef } from 'react'
import './Dialog.scss'
import { useTranslation } from 'react-i18next'
export interface DialogProps extends PropsWithChildren {
  open?: boolean
  onClose: () => void
  icon?: string | null
  title?: string | null
  width?: number
  class?: string
}

export function Dialog(props: DialogProps) {
  const backdropRef = useRef<HTMLDivElement>(null)
  const { t } = useTranslation()

  const handleDialogClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === backdropRef.current) {
      props.onClose()
    }
  }

  return (
    props.open ? (
      <div ref={backdropRef} className="dialog-backdrop" onClick={handleDialogClick}>
        <div style={{width: props.width}} className={`dialog ${props.class ?? ''}`}>
          {!!props.title && (
            <div className="dialog-header">
              {!!props.icon && <i className={props.icon}></i>}
              <span>{props.title}</span>
            </div>
          )}

          <div className="dialog-body">{props.children}</div>
          <button title={t('CLOSE') ?? 'Close'} className="dialog-close-button" onClick={props.onClose}>
            <i className="icon-close" />
          </button>
        </div>
      </div>
    ): null
  )
}
